import http from 'axios';

const state = {
  _userInfo: {}, // 用户信息
  _loginVisible: false,
  _registerVisible: false,
  _findPwdVisible: false
};

const getters = {
  userInfo: (state) => state._userInfo,
  loginStatus: (state) => !!Object.keys(state._userInfo).length,
  loginVisible: (state) => state._loginVisible,
  registerVisible: (state) => state._registerVisible,
  findPwdVisible: (state) => state._findPwdVisible,
  isOrdinaryMember: (state) => state._userInfo.level === 0,
  vipType: ({ _userInfo: ui }) => {
    let type = '';
    switch (ui.level) {
      case 0:
        if (ui.tmpLevel > 0 && ui.tmpLevelType >= 0) {
          type = '临时会员';
        } else {
          type = '普通用户';
        }
        break;
      case 25:
      case 38:
      case 40:
        type = '个人vip';
        break;
      default:
        if (ui && Object.keys(ui).length) {
          type = '企业vip';
        } else {
          type = '未登录';
        }
        break;
    }
    return type;
  }
};

const mutations = {
  changeLogin(state, data) {
    state._userInfo = Object.keys(data).length ? data : {};
  },
  changeLoginVisible(state, flag) {
    state._loginVisible = flag;
  },
  changeRegisterVisible(state, flag) {
    state._registerVisible = flag;
  },
  changeFindPwdVisible(state, flag) {
    state._findPwdVisible = flag;
  }
};

const actions = {
  /**
   * 获取session
   */
  async fetchUserInfo({ commit }) {
    const { data } = await http.get('/session');
    commit('changeLogin', data.code === 200 ? data.data : {});
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
